import { createTheme } from '@material-ui/core'

export const darkTheme = createTheme({
  palette: {
    primary: {
      main: '#393939'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF'
    },
    background: {
      default: '#121212',
      paper: '#121212'
    }
  }
})
